// Estados de una orden y sus etiquetas exactas (§5). La autoridad sobre transiciones vive en el
// servidor; este módulo replica las reglas para la UI y se verifica contra los mismos casos.

export const ORDER_STATUSES = [
  'ingreso_os',
  'ruta',
  'chequeo_repuestos',
  'repuesto_despachado',
  'listo',
  'objetada',
  'cerrada',
  'anulacion',
] as const;

export type OrderStatus = (typeof ORDER_STATUSES)[number];

export const STATUS_LABELS: Record<OrderStatus, string> = {
  ingreso_os: 'Ingreso OS',
  ruta: 'Ruta',
  chequeo_repuestos: 'Chequeo Solicitud Repuestos',
  repuesto_despachado: 'Repuesto Despachado',
  listo: 'Listo',
  objetada: 'Objetada',
  cerrada: 'Cerrado',
  anulacion: 'Anulado',
};

/** Listo ya no es definitivo: queda en revisión del personal administrativo hasta Cerrado. */
export const FINAL_STATUSES: ReadonlySet<OrderStatus> = new Set(['cerrada', 'anulacion']);

export function isFinalStatus(status: OrderStatus): boolean {
  return FINAL_STATUSES.has(status);
}

/** En curso: el trabajo no ha terminado (incluye Objetada; excluye Listo, que espera revisión, y las definitivas). */
export function isInProgress(status: OrderStatus): boolean {
  return status !== 'listo' && !isFinalStatus(status);
}

export function isOrderStatus(value: unknown): value is OrderStatus {
  return typeof value === 'string' && (ORDER_STATUSES as readonly string[]).includes(value);
}
